import { useEffect } from "react";
import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import RevenueGrowthEngine from "./sections/RevenueGrowthEngine";
import KeyTakeaways from "./sections/KeyTakeaways";
import ConsultantAnswer from "./sections/ConsultantAnswer";
import ModernHotelsEngine from "./sections/ModernHotelsEngine";
import WhereHotelsLeakRevenue from "./sections/WhereHotelsLeakRevenue";
import TheRevbabaAdvantage from "./sections/TheRevbabaAdvantage";
import CoreConsultancyPillars from "./sections/CoreConsultancyPillars";
import ServiceGrid from "./sections/ServiceGrid";
import DirectConsulting from "./sections/DirectConsulting";
import Testimonials from "./sections/Testimonials";
import ExpertiseInAction from "./sections/ExpertiseInAction";
import HospitalityIntelligenceFaq from "./sections/HospitalityIntelligenceFaq";
import LatestRevenueInsights from "./sections/LatestRevenueInsights";
import FooterInformation from "@/reusable_sections/Footer";
import faqItems from "./faq.json";
export default function HomePage() {
  useEffect(() => {
    const faqSchemaItems = faqItems.map(item => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer
      }
    }));
    const schemaGraph = {
      "@context": "https://schema.org",
      "@graph": [{
        "@type": "ProfessionalService",
        "@id": "https://hotelrevbaba.com/#organization",
        name: "HotelRevBaBa",
        url: "https://hotelrevbaba.com",
        logo: "https://hotelrevbaba.com/wp-content/uploads/logo.png",
        description: "Hotel revenue management and OTA distribution consultancy delivering daily pricing updates, channel rate parity management, extranet audits, and RevPAR growth for boutique and independent properties.",
        priceRange: "$$",
        telephone: "+91-79721-95929",
        email: "hotelrevbaba@gmail.com",
        address: {
          "@type": "PostalAddress",
          streetAddress: "Udhana",
          addressLocality: "Surat",
          addressRegion: "Gujarat",
          postalCode: "394210",
          addressCountry: "IN"
        },
        geo: {
          "@type": "GeoCoordinates",
          latitude: "21.1415",
          longitude: "72.8436"
        },
        openingHoursSpecification: [{
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          opens: "09:00",
          closes: "19:00"
        }],
        founder: {
          "@type": "Person",
          name: "Sunil Singh",
          jobTitle: "Hotel Revenue & Distribution Consultant"
        },
        areaServed: [{
          "@type": "Country",
          name: "India"
        }, {
          "@type": "AdministrativeArea",
          name: "Worldwide"
        }],
        knowsAbout: ["Hotel Revenue Management", "OTA Audits", "Dynamic Pricing", "RevPAR Optimization", "Rate Parity", "Channel Manager Integration"],
        hasOfferCatalog: {
          "@type": "OfferCatalog",
          name: "Hotel Revenue Services",
          itemListElement: [{
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Free Hotel Revenue Audit",
              description: "A 14-day audit of OTA extranets, rate parity leakage, commission tiers, and distribution gaps."
            }
          }, {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dynamic Pricing & Yield Management",
              description: "Daily room rate adjustments based on market demand compression, compset pricing, and booking pickup pace."
            }
          }, {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "OTA Distribution & Channel Management",
              description: "Protecting channel parity and managing inventory across MakeMyTrip, Agoda, Booking.com, and Expedia."
            }
          }]
        }
      }, {
        "@type": "FAQPage",
        "@id": "https://hotelrevbaba.com/#faq",
        url: "https://hotelrevbaba.com/",
        publisher: {
          "@id": "https://hotelrevbaba.com/#organization"
        },
        mainEntity: faqSchemaItems
      }]
    };
    const scriptId = "home-jsonld";
    let scriptTag = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!scriptTag) {
      scriptTag = document.createElement("script");
      scriptTag.type = "application/ld+json";
      scriptTag.id = scriptId;
      document.head.appendChild(scriptTag);
    }
    scriptTag.textContent = JSON.stringify(schemaGraph);
    return () => {
      const el = document.getElementById(scriptId);
      if (el) {
        el.remove();
      }
    };
  }, []);
  return <div>
      <MainNavigation />
      <RevenueGrowthEngine />
      <KeyTakeaways />
      <ConsultantAnswer />
      <ModernHotelsEngine />
      <WhereHotelsLeakRevenue />
      <TheRevbabaAdvantage />
      <CoreConsultancyPillars />
      <ServiceGrid />
      <DirectConsulting />
      <Testimonials />
      <ExpertiseInAction />
      <HospitalityIntelligenceFaq />
      <LatestRevenueInsights />
      <FooterInformation />
    </div>;
}